import React from 'react'
import { Box, Typography } from '@material-ui/core'

import { ICorporation } from '../../../graphql/types/businesses'

interface IProps {
  item: ICorporation
}

export const CountryColumn: React.FC<IProps> = ({ item }) => {
  if (!item.country) {
    return null
  }

  return (
    <Box>
      <Typography variant='body1'>{item.country.name}</Typography>
      <Typography color='textSecondary' variant='body2'>
        {`Кол-во городов: ${item.cities?.length ?? 0}`}
      </Typography>
    </Box>
  )
}
